module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/v2/partenariat2@3x-42e1b0e4c42b6c833d544a5028968dbe.jpg";